export default __webpack_public_path__ + "static/ecg-ab172f7a8189f17b2833c274ad0e7d52.jpg";